import { render } from "./tabs-device.vue?vue&type=template&id=e1168774&ts=true"
import script from "./tabs-device.vue?vue&type=script&lang=ts"
export * from "./tabs-device.vue?vue&type=script&lang=ts"

import "./tabs-device.vue?vue&type=style&index=0&id=e1168774&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__